<style lang="scss" scoped>
  .box-live{
    background-color: #FFFFFF;
    .list-con{
      padding: 10px;
      padding-left: 18px;
    }
    .live-item{
      background-color: #F7F7F7;
      display: inline-block;
      margin-right: 14px;
      cursor: pointer;
      &:last-child{
        margin-right: 0;
      }
    }
    .title{
      padding: 14px;
      font-size: 14px;
      border-bottom: 1px solid #eaeaea;
      margin-bottom: 10px;
    }
    .img{
      /*width: 182px;*/
      /*height: 104px;*/
      padding-top: 54.94505494505495%;
      background-color: #aaaaaa;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100%;
    }
    .img-item{
      width: 16px;
      vertical-align: middle;
    }
    .con{
      padding: 10px;
      border-bottom: 1px solid #eaeaea;
      font-size: 12px;
      color: #aaaaaa;
        font-size: 14px;
      h2{
        color: #000000;
      }
      .time{
        overflow: hidden;
        margin-top: 2px;
      }
    }
    .count{
      padding: 10px;
      overflow: hidden;
    }
    .left{
      float: left;
    }
    .right{
      float: right;
    }
    .more{
      color: #1449A5;
      cursor: pointer;
    }
  }
</style>
<template>
<div class="box-live">
  <div v-if="showTop" class="title">
    <span :style="{color: color}">{{ $t("message.live") }}</span>
    <span @click="more" :style="{color: color}" class="right more">{{ $t("message.more") }} 》</span>
  </div>
  <ul :class="{'list-con':padding}" style="height: 650px;overflow-y: auto">
    <li @click="goLive(item)" :style="{width: width+'px'}" class="live-item" v-for="(item,i) in lives" :key="i">
      <div class="img" :style="{backgroundImage: `url(${item.imgUrl})`}"></div>
      <div class="con">
        <h2>{{item.liveTitle?item.liveTitle: '暂无标题'}}</h2>
        <p class="time"><span class="left">{{item.liveStartDt|formatDt}}</span><span class="right">{{item.liveDt}}</span></p>
      </div>
      <div class="count">
        <div class="left">
          <img class="img-item" src="../../common/imgs/play.svg" alt="">
          <span>{{item.liveViewNum}} {{ $t("message.times") }}</span>
        </div>
        <div class="right">
          <img class="img-item" src="../../common/imgs/edit.svg" alt="">
          <span>{{item.liveComtNum}}</span>
        </div>
      </div>
    </li>
  </ul>
</div>
</template>
<script>
  export default {
    data() {
      return {}
    },
    props: {
      width: {
        type: Number,
        default: 182
      },
      data: {
        type: Object,
        default: {}
      },
      showNum: {
        type: Number,
        default: 4
      },
      showTop:{
        type: Boolean,
        default: true
      },
      padding:{
        type: Boolean,
        default: true
      },
      color:{
        type: String,
        default: '#333'
      }
    },
    filters:{
      formatDt (time){
        return new Date(time).Format('yyyy-MM-dd')
      }
    },
    methods: {
      more(){
        const url = location.origin+ '/webpc/live/'+ this.$route.params.cid
        window.open(url)
      },
      goLive(live){
        const url = window.origin + '/webpc/livedetails/' + live.liveId
        window.open(url);
      },
    },
    computed: {
      icons(){
        if(!this.data.cpnData) return ''
        let ret = []
        ret[0] = this.data.cpnData.icons.unliveurl
        ret[1] = this.data.cpnData.icons.livingurl
        ret[2] = this.data.cpnData.icons.pauseurl
        ret[3] = this.data.cpnData.icons.endurl
        ret[4] = this.data.cpnData.icons.reliveurl
        return ret
      },
      lives(){
        if(!this.data.cpnData) return ''
        let icons = this.data.cpnData.icons
        let lives = this.data.cpnData.lives.slice(0,this.showNum)
        return lives.map((item,i)=>{
         /*
          0 未开始  1 直播中 2 暂停 3 已结束 4 直播回顾
          */
          if(item.liveStatus*1 === 1){
            item.imgUrl = item.liveVideoPicture ? item.liveVideoPicture : icons.livingurl;
          }else{
            item.imgUrl = this.icons[item.liveStatus*1];
          }
          return item
        })
      }
    },
    mounted() {
      console.log(this.icons)
      console.log(this.lives)
    }
  }
</script>




// WEBPACK FOOTER //
// livecom.vue?7b204e75